import { createStore, applyMiddleware, compose } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
// import sagas from './sagas';

const persistConfig    = { key: 'root', storage, blacklist: [] };
const sagaMiddleware   = createSagaMiddleware();
const persistedReducer = persistReducer( persistConfig, reducers );
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store            = createStore( persistedReducer, composeEnhancers( applyMiddleware( sagaMiddleware ) ) );
const persistor        = persistStore( store );

export { store, persistor, sagaMiddleware };